export const BATCH_PRINT_LABEL_PRINTED_CHECK_START = 'BATCH_PRINT_LABEL_PRINTED_CHECK_START';
export const startLabelPrintedCheck = (fulfillmentPlanSetIds, autoPrint = false, shouldIgnoreQuickshipSettings = true) => ({
  type: BATCH_PRINT_LABEL_PRINTED_CHECK_START,
  fulfillmentPlanSetIds,
  autoPrint,
  shouldIgnoreQuickshipSettings,
});

export const BATCH_GRID_PRINT_LABEL_REQUEST = 'BATCH_GRID_PRINT_LABEL_REQUEST';
export const printLabelRequest = (
  fulfillmentPlanSetIds,
  autoPrint = false,
  labelCount = 0,
  alreadyPrintedCount = 0,
  errorsAndWarnings = [],
  shouldIgnoreQuickshipSettings = true, // I don't like this, should refactor out
) => ({
  type: BATCH_GRID_PRINT_LABEL_REQUEST,
  fulfillmentPlanSetIds,
  autoPrint,
  labelCount,
  alreadyPrintedCount,
  errorsAndWarnings,
  shouldIgnoreQuickshipSettings,
});

export const BATCH_GRID_PRINT_PACKING_SLIP_REQUEST = 'BATCH_GRID_PRINT_PACKING_SLIP_REQUEST';

export const printPackingSlipRequest = ({
  fulfillmentPlanSetIds,
  autoPrint = false,
  documentCount = 0,
  alreadyPrintedCount = 0,
  errorsAndWarnings = [],
  fulfillmentPlanIds = [],
}) => ({
  type: BATCH_GRID_PRINT_PACKING_SLIP_REQUEST,
  fulfillmentPlanSetIds,
  autoPrint,
  documentCount,
  alreadyPrintedCount,
  errorsAndWarnings,
  fulfillmentPlanIds,
});

export const BATCH_PACKING_SLIP_PRINTED_CHECK_START = 'BATCH_PACKING_SLIP_PRINTED_CHECK_START';
export const startPackingSlipPrintedStatusCheck = (fulfillmentPlanSetIds, autoPrint) => {
  return {
    type: BATCH_PACKING_SLIP_PRINTED_CHECK_START,
    fulfillmentPlanSetIds,
    autoPrint,
  };
};

export const BATCH_PRINT_OTHER_FORMS = 'BATCH_PRINT_OTHER_FORMS';
export const batchPrintOtherForms = (fulfillmentPlanSetId) => ({
  type: BATCH_PRINT_OTHER_FORMS,
  fulfillmentPlanSetId,
});
